import React, { useEffect, useState } from "react";
import Orange_Btn from "../../common_btn/orange_btn/Orange_Btn";
import { Form, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import "./Login_Modal.css";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import PasswordChecklist from "react-password-checklist";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Reset_Password_Modal from "../reset_password_modal/Reset_Password_Modal";
import { useDispatch, useSelector } from "react-redux";
import {
  UserLogin,
  userSignUp,
  sendOtp,
  verifyMobOtp,
} from "../../../../features/auth/authSlice";
import SignUp_Modal from "./Signup_Modal";
import { myAccount } from "../../../../features/my_account/Slice";
import { getAllCart } from "../../../../features/cart/cartSlice";
import { getAllWishlist } from "../../../../features/wishlist/wishlistSlice";
import Green_btn from "../../common_btn/green_btn/Green_btn";
import { appSetup } from "../../../../features/master/masterSlice";

const Login_Modal = ({ email, contact, setContact, setEmail, ...props }) => {
  const [showSignUp, setShowSignUp] = useState(false);

  // const [contact_no, setContact_no] = useState("");
  // const [otp, setOtp] = useState("");

  // ✅ NEW STATES
  const [loginType, setLoginType] = useState("mobile"); // mobile | email
  const [otpSent, setOtpSent] = useState(false);

  const [timer, setTimer] = useState(0);
  const [isTimerRunning, setIsTimerRunning] = useState(false);

  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordOne, setShowPasswordOne] = useState(false);
  const [iconOne, setIconOne] = useState(faEyeSlash);
  const [iconTwo, setIconTwo] = useState(faEyeSlash);

  const togglePasswordVisibility = (field) => {
    if (field === "password") {
      setShowPassword(!showPassword);
      setIconOne(showPassword ? faEyeSlash : faEye);
    } else if (field === "reenterPassword") {
      setShowPasswordOne(!showPasswordOne);
      setIconTwo(showPasswordOne ? faEyeSlash : faEye);
    }
  };

  const {
    register,
    handleSubmit,
    setError,
    getValues,
    reset,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();
  const isSignin = useSelector((state) => state.auth.is_signin);

  useEffect(() => {
    let interval = null;

    if (isTimerRunning && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }

    if (timer === 0) {
      setIsTimerRunning(false);
    }

    return () => clearInterval(interval);
  }, [isTimerRunning, timer]);

  const onSubmit = async (data) => {
    // const res = await dispatch(UserLogin(data));

    const payload = {
      email_or_contact: data.email, //FIX
      password: data.password,
    };

    const res = await dispatch(UserLogin(payload));

    if (res.meta?.requestStatus === "fulfilled") {
      reset();

      dispatch(getAllCart(isSignin));
      dispatch(getAllWishlist());
      dispatch(myAccount());
      props?.onHide();
      props.setShowLogin();
    } else if (res.meta?.requestStatus === "rejected") {

      console.log(res?.payload?.errors?.email_or_contact,"errorrr for email +++++++++")

      if (res.payload?.errors) {
        setError("email", {
          type: "manual",
          message: res?.payload?.errors?.email_or_contact,
        });
      }
      if (res.payload?.errors?.password) {
        setError("password", {
          type: "manual",
          message: res.payload?.errors?.password,
        });
      }
    }
  };

  const app_setup = useSelector((state) => state.master.app_setup);

  return (
    <Modal className="Login_Modal" size="md" {...props} centered>
      <div className="absolute_div">
        <p className="modal_title">{showSignUp ? "SIGN UP" : "LOGIN"}</p>

        <div className="logo_holder">
          <img
            src={process.env.REACT_APP_IMG_URL + app_setup?.logo}
            className="logo_img"
          />
        </div>
      </div>

      <Modal.Body>
        <div className="close_img_div">
          <img
            src="/assets/images/modal/close.png"
            className="close_img"
            onClick={() => {
              reset();
              setOtpSent(false);
              setIsTimerRunning(false);
              setTimer(0);
              setLoginType("mobile");
              props?.onHide();
            }}
          />
        </div>

        {!showSignUp && (
          <div className="login_div">
            <div className="login_form_div">
              <Form>
                {/* ✅ LOGIN TYPE SWITCH (NO CLASS CHANGE) */}
                <div className="input_group login_tab_wrapper">
                  <div
                    className={`login_tab ${loginType === "mobile" ? "active" : ""
                      }`}
                    onClick={() => {
                      setLoginType("mobile");
                      setOtpSent(false);
                      reset();
                    }}
                  >
                    Login with Mobile
                  </div>

                  <div
                    className={`login_tab ${loginType === "email" ? "active" : ""
                      }`}
                    onClick={() => {
                      setLoginType("email");
                      reset();
                    }}
                  >
                    Login with Email
                  </div>
                </div>

                {/* ✅ MOBILE LOGIN */}
                {loginType === "mobile" && (
                  <>
                    <Form.Group className="gray_input_group input_group">
                      <Form.Label>Mobile Number</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Mobile Number"
                        // {...register("mobile", {
                        //   required: "Mobile number is required",
                        // })}
                        {...register("mobile", {
                          required: "Mobile number is required",
                          pattern: {
                            value: /^[0-9]+$/,
                            message: "Only numbers are allowed",
                          },
                          minLength: {
                            value: 10,
                            message: "Mobile number must be 10 digits",
                          },
                          maxLength: {
                            value: 10,
                            message: "Mobile number must be 10 digits",
                          },
                        })}
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/[^0-9]/g, "");
                        }}
                      // onChange={(e) => setContact_no(e.target.value)}
                      />
                      {errors?.mobile && (
                        <sup className="text-danger">
                          {errors?.mobile?.message}
                        </sup>
                      )}
                    </Form.Group>

                    {!otpSent && (
                      <div className="btn_holder">

                        {/* 
                        <Green_btn
                          btnText="Send OTP"
                          // onClick={handleSubmit((data) => {
                          //   console.log("Send OTP API", data);
                          //   setOtpSent(true);
                          // })}
                          onClick={handleSubmit(async (data) => {
                            const res = await dispatch(
                              sendOtp({ contact_no: data.mobile }), //FIX
                            );

                            if (res.meta.requestStatus === "fulfilled") {
                              setOtpSent(true);
                            } else {
                              setError("mobile", {
                                type: "manual",
                                message:
                                  res.payload?.message || "Failed to send OTP",
                              });
                            }
                          })}
                        />
 */}

                        <Green_btn
                          btnText={isTimerRunning ? `Resend OTP in ${timer}s` : "Send OTP"}
                          disabled={isTimerRunning} // disable during timer
                          onClick={handleSubmit(async (data) => {
                            const res = await dispatch(sendOtp({ contact_no: data.mobile }));

                            if (res.meta.requestStatus === "fulfilled") {
                              setOtpSent(true);
                              setTimer(90);
                              setIsTimerRunning(true);  // STOP TIMER

                              //setIsTimerRunning(true);
                            }
                            else {
                              setError("mobile", {
                                type: "manual",
                                message: res.payload?.message || "Failed to send OTP",
                              });
                            }
                          })}
                        />

                      </div>
                    )}


                    {otpSent && (

                      <>
                        <Form.Group className="gray_input_group input_group">
                          <Form.Label>Enter OTP</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter OTP"
                            {...register("otp", {
                              required: "OTP is required",
                            })}
                          // onChange={(e) => setOtp(e.target.value)}
                          />
                          {errors?.otp && (
                            <sup className="text-danger">
                              {errors?.otp?.message}
                            </sup>
                          )}
                        </Form.Group>

                        <div className="btn_holder">
                          {/*<Green_btn
                            btnText="Verify & Login"
                            onClick={handleSubmit((data) => {
                              console.log("Verify OTP API", data);
                            })}
                          />*/}

                          <div className="btn_holder">

                            {!isTimerRunning ? (
                              // When timer finished → show Resend
                              <Green_btn
                                btnText="Resend OTP"
                                onClick={async () => {
                                  const mobile = getValues("mobile");

                                  if (!mobile) {
                                    setError("mobile", {
                                      type: "manual",
                                      message: "Mobile number is required",
                                    });
                                    return;
                                  }

                                  const res = await dispatch(sendOtp({ contact_no: mobile }));

                                  if (res.meta.requestStatus === "fulfilled") {
                                    setTimer(90);
                                    setIsTimerRunning(true);
                                  }
                                }}
                              />




                            ) : (
                              // Timer still running → disabled
                              <Green_btn
                                btnText={`${timer}s`}
                                disabled={true}
                              />
                            )}

                          </div>


                          {isTimerRunning && (
                            <Green_btn
                              btnText="Verify & Login"

                              onClick={handleSubmit(async (data) => {
                                const res = await dispatch(
                                  verifyMobOtp({
                                    contact_no: data.mobile, //FIX
                                    otp: data.otp,
                                  }),
                                );

                                if (res.meta.requestStatus === "fulfilled") {
                                  // const token = res.payload?.data?.token;

                                  // if (token) {
                                  //   localStorage.setItem("token", token);

                                  reset(); //ADD
                                  setOtpSent(false);

                                  dispatch(getAllCart());
                                  dispatch(getAllWishlist());
                                  dispatch(myAccount());

                                  props?.onHide();
                                  props.setShowLogin();

                                } else {
                                  setError("otp", {
                                    type: "manual",
                                    message: res.payload || "Invalid OTP",
                                  });
                                }
                              })}

                            />
                          )}

                        </div>
                      </>
                    )}


                  </>
                )}

                {/* ✅ EMAIL LOGIN */}
                {loginType === "email" && (
                  <>
                    <Form.Group className="gray_input_group input_group">
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Email"
                        {...register("email", {
                          required: "Email is required",
                          pattern: {
                            value: /^[A-Za-z0-9](?:[A-Za-z0-9.+]*[A-Za-z0-9])?@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)*\.(?:com|in|ac|net|org|info|co\.in|gov|edu|tech|io)$/i,
                            message: "Please enter a valid email address",
                          },
                        })}
                      />
                      {errors?.email && (
                        <sup className="text-danger">
                          {errors?.email?.message}
                        </sup>
                      )}
                    </Form.Group>

                    <Form.Group className="gray_input_group input_group">
                      <Form.Label>Password</Form.Label>
                      <div className="password_holder">
                        <Form.Control
                          type={showPassword ? "text" : "password"}
                          placeholder="Enter Password"
                          {...register("password", {
                            required: "Password is required",
                          })}
                        />
                        <div className="eye-icc">
                          <FontAwesomeIcon
                            icon={iconOne}
                            className="icon"
                            onClick={() => togglePasswordVisibility("password")}
                          />
                        </div>
                      </div>
                      {errors?.password && (
                        <sup className="text-danger">
                          {errors?.password?.message}
                        </sup>
                      )}

                      <p
                        className="link_text"
                        onClick={() => {
                          props?.onHide();
                          props?.setShowResetModal();
                        }}
                      >
                        Forgot Password?
                      </p>
                    </Form.Group>

                    <div className="btn_holder">
                      <Green_btn
                        btnText="Login"
                        onClick={handleSubmit(onSubmit)}
                      />
                    </div>
                  </>
                )}
              </Form>
            </div>

            <p className="dark_text">
              Don't have an account?{" "}
              <span
                className="link_text"
                onClick={() => {
                  setShowSignUp(true);
                }}
              >
                Create Account
              </span>
              .
            </p>
          </div>
        )}

        {showSignUp && (
          <SignUp_Modal
            setShowSignUp={setShowSignUp}
            showSignUp={showSignUp}
            setShowAccountCreted={props?.setShowAccountCreted}
            onHide={props?.onHide}
          />
        )}
      </Modal.Body>
    </Modal>
  );
};

export default Login_Modal;
